import { PageHeader } from "@/components/layouts/PageHeader";
import NewsAlertsContent from "@/components/news-alerts/NewsAlertsContent";
import { logoutUser } from "@/store/auth.async-actions";
import useAuth, { type AuthState } from "@/store/auth.slice";

/**
 * News Alerts route component for TanStack Router.
 * Provides PageHeader + NewsAlertsContent.
 */
const NewsAlertsRoute = () => {
  const user = useAuth((state: AuthState) => state.user);

  return (
    <>
      <PageHeader
        label="News Alerts"
        showFeedSwitcher={false}
        userEmail={user?.email ?? ""}
        userTenantName={user?.default_tenant?.name}
        onLogout={logoutUser}
      />
      <main className="flex h-[calc(100vh-80px)]">
        <NewsAlertsContent />
      </main>
    </>
  );
};

export default NewsAlertsRoute;
